/* Live suggestions for snippets/catalog-search.liquid. */
(() => {
  const form = document.querySelector('[data-catalog-search]');
  if (!form) return;

  const input = form.querySelector('.catalog-search__input');
  const panel = form.querySelector('.catalog-search__panel');
  const status = form.querySelector('[data-catalog-search-status]');
  const minLength = 2;

  let controller = null;
  let timer = null;
  let activeIndex = -1;

  const formatPrice = (value) =>
    `${Number(value).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} lei`;

  const options = () => [...panel.querySelectorAll('[role="option"]')];

  const close = () => {
    panel.hidden = true;
    panel.replaceChildren();
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    activeIndex = -1;
  };

  const setActive = (index) => {
    const items = options();
    items.forEach((item, i) => item.setAttribute('aria-selected', String(i === index)));
    activeIndex = index;
    if (index >= 0) {
      input.setAttribute('aria-activedescendant', items[index].id);
      items[index].scrollIntoView({ block: 'nearest' });
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  };

  const heading = (text) => {
    const el = document.createElement('div');
    el.className = 'catalog-search__heading';
    el.textContent = text;
    return el;
  };

  const highlight = (target, text, term) => {
    const at = text.toLowerCase().indexOf(term.toLowerCase());
    if (at === -1) {
      target.textContent = text;
      return;
    }
    const mark = document.createElement('mark');
    mark.textContent = text.slice(at, at + term.length);
    target.append(text.slice(0, at), mark, text.slice(at + term.length));
  };

  const productRow = (product, term, id) => {
    const link = document.createElement('a');
    link.className = 'catalog-search__option';
    link.id = id;
    link.href = product.url;
    link.setAttribute('role', 'option');

    if (product.image) {
      const img = document.createElement('img');
      img.src = `${product.image}${product.image.includes('?') ? '&' : '?'}width=112`;
      img.alt = '';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      link.append(img);
    }

    const text = document.createElement('span');
    text.className = 'catalog-search__option-title';
    highlight(text, product.title, term);
    link.append(text);

    if (product.price) {
      const price = document.createElement('span');
      price.className = 'catalog-search__option-price';
      price.textContent = formatPrice(product.price);
      link.append(price);
    }
    return link;
  };

  const render = (term, products, collections) => {
    panel.replaceChildren();
    let n = 0;

    if (products.length) {
      panel.append(heading('Produse'));
      products.forEach((p) => panel.append(productRow(p, term, `csr-${n++}`)));
    }

    if (collections.length) {
      panel.append(heading('Categorii'));
      collections.forEach((c) => {
        const link = document.createElement('a');
        link.className = 'catalog-search__option catalog-search__option--text';
        link.id = `csr-${n++}`;
        link.href = c.url;
        link.setAttribute('role', 'option');
        link.textContent = c.title;
        panel.append(link);
      });
    }

    if (!products.length && !collections.length) {
      const empty = document.createElement('p');
      empty.className = 'catalog-search__empty';
      empty.textContent = `Nu am găsit nimic pentru „${term}”. Încearcă alt cuvânt sau scrie-ne pe WhatsApp.`;
      panel.append(empty);
    } else {
      const all = document.createElement('a');
      all.className = 'catalog-search__all';
      all.id = `csr-${n++}`;
      all.href = `${form.action}?type=product&q=${encodeURIComponent(term)}`;
      all.setAttribute('role', 'option');
      all.textContent = `Vezi toate rezultatele pentru „${term}”`;
      panel.append(all);
    }

    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    activeIndex = -1;
    status.textContent = products.length
      ? `${products.length} sugestii disponibile`
      : 'Nicio sugestie';
  };

  const search = async (term) => {
    controller?.abort();
    controller = new AbortController();
    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product,collection',
      'resources[limit]': '5',
      'resources[options][unavailable_products]': 'last',
    });
    try {
      const response = await fetch(`/search/suggest.json?${params}`, { signal: controller.signal });
      if (!response.ok) throw new Error(response.status);
      const { resources } = await response.json();
      const { products = [], collections = [] } = resources.results;
      render(term, products, collections);
    } catch (error) {
      if (error.name !== 'AbortError') close();
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const term = input.value.trim();
    if (term.length < minLength) {
      controller?.abort();
      close();
      return;
    }
    timer = setTimeout(() => search(term), 200);
  });

  input.addEventListener('keydown', (event) => {
    const items = options();
    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'ArrowDown' && items.length) {
      event.preventDefault();
      setActive((activeIndex + 1) % items.length);
    } else if (event.key === 'ArrowUp' && items.length) {
      event.preventDefault();
      setActive((activeIndex - 1 + items.length) % items.length);
    } else if (event.key === 'Enter' && activeIndex >= 0) {
      event.preventDefault();
      items[activeIndex].click();
    }
  });

  document.addEventListener('click', (event) => {
    if (!form.contains(event.target)) close();
  });

  document.addEventListener('keydown', (event) => {
    const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);
    if (event.key === '/' && !typing && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      input.focus();
    }
  });
})();
